import { ApiLinkEntity, ApiLinkRel, UserPermission } from "config/constants"
import { Guid, IApiLink } from "@/types"
import { Role } from "./UserRoles"

export interface IGetUserDto {
    id: Guid
    language: string
    email: string
    roles: Role[]
    permissions: UserPermission[]
    links: IApiLink[]
}

export interface IInitUserDto extends IGetUserDto {
    firstName?: string
    lastName?: string
    name?: string
    companyName?: string
    companyId?: string
}

export default class User {
    id: Guid
    language: string
    email: string
    roles: Role[]
    permissions: UserPermission[]
    firstName?: string
    lastName?: string
    name?: string
    companyName?: string
    companyId?: string

    linkUpdate?: IApiLink

    constructor(dto: IInitUserDto) {
        this.id = dto.id
        this.language = dto.language
        this.roles = dto.roles
        this.permissions = dto.permissions
        this.email = dto.email
        this.firstName = dto.firstName
        this.lastName = dto.lastName
        this.name = dto.name
        this.companyName = dto.companyName
        this.companyId = dto.companyId

        this.linkUpdate = dto.links.find(link => link.entity === ApiLinkEntity.user && link.rel === ApiLinkRel.partialUpdate)

        if (import.meta.env.NODE_ENV !== "test") {
            console.log("User permissions", { permissions: this.permissions })
        }
    }

    get fullName() {
        if (!this.firstName && !this.lastName) {
            return this.name || ""
        }

        return [
            this.firstName ? this.firstName : "",
            this.lastName ? this.lastName : ""
        ].join(" ")
    }

    get nameAbbr(): string {
        if (!this.firstName && !this.lastName) {

            // in the name we can heve either email or full name
            // so first we try to return abbreviation from full name, then from email.
            // the aim is to return at least two letters if it's possible

            if (!this.name) return ""

            const name = this.name.split("@")[0]
            let namePartsSpace = name.split(" ")
            let namePartsDot = name.split(".")
            let nameParts: string[] = []
            if (namePartsSpace.length >= 2) {
                nameParts = namePartsSpace
            } else if (namePartsDot.length >= 2) {
                nameParts = namePartsDot
            } else if (namePartsSpace.length >= 1) {
                nameParts = namePartsSpace
            } else if (namePartsDot.length >= 1) {
                nameParts = namePartsDot
            } else {
                return ""
            }

            return [
                nameParts[0][0],
                nameParts[1] ? nameParts[1][0] : ""
            ].join("")
        }

        return [
            this.firstName ? this.firstName[0] : "",
            this.lastName ? this.lastName[0] : ""
        ].join("")
    }

    hasPermission(permission: UserPermission) {
        return this.permissions.includes(permission)
    }

    hasRole(role: Role) {
        return this.roles.includes(role)
    }

}

